import {
  Box,
  Button,
  Collapse,
  Flex,
  Grid,
  Icon,
  IconButton,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import CommonSpinner from "App/DMRC/CommonSpinner";
import { AppContext } from "AppProvider/AppContext";
import { useCallback, useContext, useEffect, useState } from "react";
import {
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaClock,
  FaEdit,
  FaTimesCircle,
} from "react-icons/fa";
import { appRequest } from "routes";
import { SELLER_CLIENT_URL } from "utils/env";

const statusColor: any = {
  PROCESSING: "yellow",
  RESOLVED: "green",
  CLOSE: "gray",
};
interface Props {
  selectedIds: {
    issueId: string;
    transactionId: string;
  };
  callApi?: boolean;
  data: any;
}

export default function IssueStatus({
  selectedIds,
  callApi,
  data,
}: Props): JSX.Element {
  const [statusData, setStatusData] = useState<any>([]);
  const [openIndex, setOpenIndex] = useState<number | any>(null);
  const { toastNotify } = useContext(AppContext);
  const [loading, setLoading] = useState<boolean>(false);

  const getIssues = useCallback(async () => {
    try {
      setLoading(true);
      const issueId = data?._id || "";
      const response: any = await appRequest("issues", "getIssueStatus", {
        issueId,
      });
      if (response?.status === "success") {
        setStatusData(response?.issue?.statusFlow || []);
      }
    } catch (err: any) {
      console.error("Error fetching data:", err);
    } finally {
      await new Promise((r: any) => setTimeout(r, 1000));
      setLoading(false);
    }
  }, [callApi]);

  // const getIssues = async () => {
  //   try {
  //     setLoading(true);
  //     const issueId = data?._id || "";
  //     const response: any = await appRequest("issues", "getIssueStatus", {
  //       issueId,
  //     });
  //     if (response?.status === "success") {
  //       setStatusData(response?.issue?.statusFlow || []);

  //     }
  //   } catch (error: any) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     await new Promise((r: any) => setTimeout(r, 1000));
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    getIssues();
  }, [data?._id, callApi]);

  const handleToggle = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading === true) {
    return <CommonSpinner h={"60px"} w={"60px"} thickness={"4px"} />;
  }

  return (
    <Box overflowY={"auto"} className="customScrollBar" maxH={"38vh"} pb={1}>
      <Grid templateColumns={{ md: "1fr 1fr" }} gap={4}>
        {statusData.map((action: any, index: number) => (
          <Box
            key={`status-${index}`}
            p={{ base: 2, md: 3 }}
            borderWidth={1}
            borderRadius="md"
            bg={
              action.status === "PROCESSING"
                ? "green.50"
                : action.status === "ESCALATED"
                ? "red.50"
                : action.status === "CLOSED"
                ? "gray.50"
                : "blue.50"
            }
            _hover={{
              bg:
                action.status === "PROCESSING"
                  ? "green.100"
                  : action.status === "ESCALATED"
                  ? "red.100"
                  : action.status === "CLOSED"
                  ? "gray.100"
                  : "blue.100",
            }}
            transition="background-color 0.3s"
            cursor={"pointer"}
            h={"fit-content"}
          >
            <Flex alignItems="center" mb={2}>
              <Icon
                as={
                  action.status === "OPEN"
                    ? FaEdit
                    : action.status === "PROCESSING"
                    ? FaClock
                    : action.status === "ESCALATED"
                    ? FaTimesCircle
                    : action.status === "CLOSED"
                    ? FaCheckCircle
                    : undefined
                }
                color={
                  action.status === "PROCESSING"
                    ? "green.500"
                    : action.status === "ESCALATED"
                    ? "red.500"
                    : action.status === "CLOSED"
                    ? "gray.500"
                    : "blue.500"
                }
                mr={2}
              />
              <Text fontWeight="bold" color="blue.800">
                {action.status}
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.600">
              Description: {action.description}
            </Text>
          </Box>
        ))}
      </Grid>
    </Box>
  );
}
